export const MapButtonGroupStyle = {
  dark: {
    fontColorActive: "$white",
    fontColorInactive: "$textLight900",
    backgroundColorActive: "$secondary800",
    backgroundColorInactive: "$secondary50",
    variant: "solid",
    borderRadius: "$lg",
    borderColorActive: "$secondar600",
    borderColorInactive: "$secondary300"
  },
  primary: {
    fontColorActive: "$primary700",
    fontColorInactive: "$textLight50",
    backgroundColorActive: "$white",
    backgroundColorInactive: undefined,
    borderRadius: "$full",
    variant: "outlined",
    borderColorActive: "$primary600",
    borderColorInactive: "$white"
  }
} as const;
